module.exports = __webpack_public_path__ + "img/shiba-body-level3.84be25e1.png";